import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'

function renderHeaderContent(h, options) {
  const { path, serviceName } = options

  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            icon: icons.integration_instructions,
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${serviceName}.subtitles.${path}`)
    ]
  )
}
function renderHeader(h, options, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderHeaderContent.call(this, h, options),
      h(arrow, { props: { expanded } })
    ]
  )
}

function renderRemoveFieldButton(h, index, length) {
  return h(
    button,
    {
      props: {
        icon: icons.remove,
        color: Colors.error,
        mode: buttonModes.flat,
        disabled: length === 1
      },
      on: {
        click: () => {
          this.remove(index)
        }
      }
    }
  )
}
function renderKeyField(h, options, item) {
  const { path, serviceName } = options

  return h(
    components['text-field'],
    {
      props: {
        value: item.key,
        label: this.getTranslate(`${serviceName}.labels.${path}.domain`),
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          item.key = event
        }
      }
    }
  )
}
function renderValueField(h, options, item) {
  const { path, serviceName } = options

  return h(
    components.select,
    {
      props: {
        value: item.value,
        label: this.getTranslate(`${serviceName}.labels.${path}.user`),
        service: Services.users,
        query: { isActive: true },
        itemTitle: 'username',
        dense: true,
        clearable: true,
        autocomplete: true,
        details: false
      },
      on: {
        input: event => {
          item.value = event
        }
      }
    }
  )
}
function renderItem(h, options, item, index, length) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8 faic',
      style: { 'grid-template-columns': '1fr 1fr auto' }
    },
    [
      renderKeyField.call(this, h, options, item),
      renderValueField.call(this, h, options, item),
      renderRemoveFieldButton.call(this, h, index, length)
    ]
  )
}
function renderItems(h, options) {
  return this.proxy?.map((item, index, items) => {
    return renderItem.call(this, h, options, item, index, items.length)
  })
}
function renderBody(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8 pt-2 px-2'
    },
    [ renderItems.call(this, h, options) ]
  )
}

function renderAddButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.add'),
        icon: icons.add,
        color: Colors.success,
        mode: buttonModes.flat
      },
      on: {
        click: () => {
          this.add()
        }
      }
    }
  )
}
function renderSaveButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.save'),
        icon: icons.save,
        color: Colors.primary,
        mode: buttonModes.flat,
        loading: this.loading,
        disabled: this.disabled
      },
      on: {
        click: () => {
          this.submit()
        }
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer'
    },
    [
      renderAddButton.call(this, h),
      renderSaveButton.call(this, h)
    ]
  )
}

function renderContent(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--0'
    },
    [
      renderBody.call(this, h, options),
      renderFooter.call(this, h)
    ]
  )
}

export default function(h, options) {
  return h(
    components['expansion-panel'],
    {
      props: {
        outline: true,
        rounded: true
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, options, expanded)
        },
        default: () => {
          return renderContent.call(this, h, options)
        }
      }
    }
  )
}
